import React from "react";
import {formatDuration} from "date-fns";
import LoadUnitOfMeasure from "../common/enum/LoadUnitOfMeasure";

interface VehicleHirePaymentMethodDefinitionListProps {
    vehicleHire: CustomerAPIVehicleHire
}

const VehicleHirePaymentMethodDefinitionList = (
    {vehicleHire}: VehicleHirePaymentMethodDefinitionListProps
) => {

    const loadRateUom = vehicleHire && vehicleHire.loadRateUnitOfMeasure && LoadUnitOfMeasure.valueOf(vehicleHire.loadRateUnitOfMeasure);

    switch (vehicleHire.paymentMethod) {
        case 'LOAD':
            return (
                <dl>
                    <dt>Loads Completed</dt>
                    <dd>{ vehicleHire.loadsCompleted || <>&mdash;</> }</dd>
                    {loadRateUom && <dt>Total {loadRateUom.description}</dt>}
                    {loadRateUom && <dd>{ vehicleHire.netTotalQty ?? vehicleHire.totalUnitOfMeasureQty ?? <>&mdash;</>}</dd>}
                </dl>
            )
        case 'HOUR':
            if (vehicleHire.workedMinutes) {
                return (
                    <dl>
                        <dt>Worked Duration</dt>
                        <dd>{formatDuration({
                            hours: Math.floor(vehicleHire.workedMinutes / 60),
                            minutes: vehicleHire.workedMinutes % 60,
                        }, {
                            format: ['hours', 'minutes']
                        })}</dd>
                    </dl>
                )
            }
            return null;
        default:
            return null;
    }

}


export default VehicleHirePaymentMethodDefinitionList;
